import * as React from "react";

interface NotificationIconProps {
	[key: string]: any;
}

const NotificationIcon: React.FC<NotificationIconProps> = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={18}
		height={20}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			d="M5.734 16.274h1.349c0 .99.755 1.792 1.686 1.792.932 0 1.687-.802 1.687-1.792h1.349c0 1.781-1.36 3.226-3.036 3.226s-3.035-1.445-3.035-3.226Z"
		/>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M17.538 14.84v-.359c0-1.264-.877-2.31-2.023-2.484V7.67c0-3.96-3.02-7.17-6.746-7.17-3.726 0-6.745 3.208-6.745 7.17v4.327C.88 12.173 0 13.218 0 14.48v.359c0 .792.605 1.434 1.35 1.434h14.84c.745 0 1.348-.639 1.348-1.434Zm-2.363-1.434c.563 0 1.014.48 1.014 1.075v.359H1.35v-.359c0-.594.455-1.075 1.015-1.075.556 0 1.009-.48 1.009-1.073V7.67c0-3.17 2.415-5.736 5.396-5.736 2.982 0 5.397 2.568 5.397 5.736v4.663c0 .59.452 1.073 1.009 1.073Z"
			clipRule="evenodd"
		/>
	</svg>
);
export default NotificationIcon;
